export class Constants {
  public static get ENTORNO(): string {
    return "LC";
  }
  public static get ROOT_URL(): string {

    let urlAPI: any;

    if (sessionStorage.getItem("urlAPI") === null) {
      var request = new XMLHttpRequest();
      request.open("GET", "./assets/config.json", false);
      request.send(null);

      if (request.status === 200) {
        urlAPI = JSON.parse(request.responseText);
        sessionStorage.setItem("urlAPI", request.responseText);
      }
    } else {
      urlAPI = JSON.parse(sessionStorage.getItem("urlAPI"));
    }

    return urlAPI.url;

    /*let url = "";
    switch (this.ENTORNO) {
      case "DV":
        url = "http://18.210.107.20/logisticaapi";
        break;
      case "QA":
        url = "http://18.210.107.20/cncaldas_webapi_qa";
        break;
      case "PR":
        url = "http://18.210.107.20/cncaldas_webapi";
        break;
      case "LC":
        url = "http://localhost/APICORELOG3";
        break;
    }
    return url;*/
  }
  public static get BASE_URL(): string {
    const url = this.ROOT_URL + "/api/";
    return url;
  }
  public static get BASE_URL_DOS(): string {
    const url = this.ROOT_URL + "/vAPIa001/";
    return url;
  }
  public static get URL_LOGIN(): string {
    return "Auth/token";
  }
  public static get URL_REFRESH(): string {
    return "renew";
  }
  public static get URL_SIGNALR(): string {
    return "chathub";
  }
  public static get URL_GRAFICAS_INICIO(): string {
    return "Auth/token";
  }
  public static get URL_MENU(): string {
    return "menu";
  }
  public static get URL_FORMULARIO(): string {
    return "formulario";
  }
  /*public static get URL_USUARIO(): string {
    return 'usuario';
  }*/
  public static get URL_REPORTE(): string {
    return "Reporte";
  }
  public static get URL_TRANSPORTADOR(): string {
    return "Transportador";
  }
  public static get URL_SERVICIO(): string {
    return "Servicio";
  }
  public static get URL_DEPARTAMENTO(): string {
    return "Departamento";
  }
  public static get URL_CIUDAD(): string {
    return "Ciudad";
  }
  public static get URL_TIPO_USUARIO(): string {
    return "TipoUsuario";
  }
  public static get URL_DIRECCION(): string {
    return "Direccion";
  }
  public static get URL_USUARIO(): string {
    return "UsuarioApp";
  }
  public static get URL_BLOQUE(): string {
    return "Bloque";
  }
  public static get URL_ENCUESTA(): string {
    return "Encuesta";
  }
  public static get URL_PREGUNTA(): string {
    return "Pregunta";
  }
  public static get URL_ENCUESTA_BLOQUE(): string {
    return "EncuestaBloque";
  }
  public static get URL_TIPO_DOCUMENTO(): string {
    return "TipoDocumento";
  }
  public static get URL_PERSONA(): string {
    return "persona";
  }
  public static get URL_ARCHIVO(): string {
    return "Archivo";
  }
  public static get URL_AGENCIA(): string {
    return "Agencia";
  }
  public static get URL_ENTREGAS(): string {
    return "Entrega";
  }
  public static get URL_IMAGEN(): string {
    return "Imagen";
  }
  public static get URL_LOGWS(): string {
    return "LogWS";
  }
  public static get URL_TIPO_NOVEDAD(): string {
    return "TipoNovedad";
  }
  public static get URL_TIPO_MOTIVO(): string {
    return "TipoMotivo";
  }
  public static get URL_MOTIVO(): string {
    return "Motivo";
  }
  public static get URL_TIPO_MOTIVO_CLAS(): string {
    return "TipoMotivoClas";
  }
  public static get URL_PERSONA_VEHICULO(): string {
    return "PersonaVehiculo";
  }
  public static get URL_VEHICULO(): string {
    return "Vehiculo";
  }
  public static get URL_TIPO_PERSONA_VEHICULO(): string {
    return "TipoPersonaVehiculo";
  }
  public static get URL_GRAFICA(): string {
    return "Grafica";
  }
  public static get URL_ENCUESTA_FIJAS(): string {
    return "EncuestaFijas";
  }
  public static get URL_PREGUNTA_FIJAS(): string {
    return "PreguntaFijas";
  }
  public static get URL_BLOQUE_FIJAS(): string {
    return "BloqueFijas";
  }
  public static get URL_ENCUESTA_BLOQUE_FIJAS(): string {
    return "EncuestaBloqueFijas";
  }
  public static get URL_BLOQUE_PREGUNTA_FIJAS(): string {
    return "BloquePreguntaFijas";
  }
  public static get URL_BLOQUE_PREGUNTA(): string {
    return "BloquePregunta";
  }
  public static get URL_TIPOS_MENSAJE(): string {
    return 'TipoMensaje';
  }
  public static get URL_MENSAJE(): string {
    return 'Mensaje';
  }
  public static get URL_PRIORIDAD(): string {
    return 'Prioridad';
  }
  public static get URL_S3(): string {
    return 's3';
  }
  public static get URL_EDIFICIO(): string {
    return 'Edificio';
  }
  public static get URL_BLOQUE_EDIFICIO(): string {
    return 'BloqueEdificio';
  }
}
